import React, { useState } from 'react';
import Button from '@mui/material/Button';
import GroovyPanel from './GroovyPanel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import OpenInFull from '@mui/icons-material/OpenInFull';
import Minimize from '@mui/icons-material/Minimize';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#groovy-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const GroovyDialog = ({ title, script, onApply, onClose }) => {
    const [value, setValue] = useState(script || "");
    const [isFullScreen, setIsFullScreen] = useState(true);

    const handleToggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    return (
        <Dialog
            fullScreen={isFullScreen}
            onClose={onClose}
            scroll={"paper"}
            open={true}
            fullWidth
            maxWidth='100%'
            PaperComponent={PaperComponent}
        >
            <DialogTitle sx={{ cursor: 'move' }} id="groovy-dialog-title">{title}</DialogTitle>
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <IconButton
                onClick={handleToggleFullScreen}
                sx={{
                    position: 'absolute',
                    right: 40,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                {isFullScreen ? <Minimize /> : <OpenInFull />}
            </IconButton>
            <DialogContent sx={{ m: 0, p: 0 }} dividers={true}>
                <GroovyPanel
                    hideOpenInNewButton
                    id="script"
                    name="script"
                    defaultValue={value}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onApply(value)}>Apply</Button>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default GroovyDialog;
